module.exports = __webpack_public_path__ + "static/media/whitelogo.40341f54.png";